<template>
    <div class="single-collection-info">
        <div>
            <span class="single-collection-info__title">{{ course.title }}</span>
            <div class="single-collection-info__container">
                <ThumbnailInfoTable itemType="course" :entity="course"/>
                <TotemSignUpTag :course="course" v-if="showSignUpToDigitalClassRoomInfo" class="single-collection-info__sign-up" />
                <TotemCompletedTag :course="course" v-if="isCompleted" />
            </div>
        </div>
        <div class="single-collection-info__description" v-if="isDesktopView && course.description">
            <span class="-v-html" v-html="course.description"></span>
        </div>
    </div>
</template>

<script>
    import ThumbnailInfoTable from 'components/shared/global-courses-items/thumbnails/ThumbnailInfoTable.vue'
    import ThumbnailTagsHelper from 'components/shared/global-courses-items/helper/thumbnail-tags-helper'

    export default {
        components: { ThumbnailInfoTable },
        props: {
            course: {
                type: Object
            }
        },
        mixins: [ ThumbnailTagsHelper ]
    }
</script>

<style lang="scss">
    .single-collection-info__description {
        &.-v-html {
            p {
                padding: 0 !important;
            }
        }
    }
</style>

<style lang="scss" scoped>
    .single-collection-info {
        display: flex;
        flex-direction: column;
        padding: 8px 20px 0 10px;

        [class*="desktop"] & {
            padding: 0;
        }

        &__container {
            display: flex;
            align-items: baseline;

            [class*="mobile"] & {
                flex-direction: column;
            }
        }

        &__sign-up {
            margin: 10px 0 20px !important;
            text-wrap: nowrap;
        }

        &__title {
            font-family: PPAgrandir-Medium, sans-serif;
            font-size: 1.6rem;
            padding: 0 10px 0 0;
            display: block;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            text-overflow: ellipsis;

            [class*="mobile_sm"] & {
                font-size: 1.25rem;
            }

            [class*="desktop"] & {
                font-size: 1.6rem;
            }
        }

        &__description {
            font-family: PlusJakartaSans-Regular, sans-serif;
            font-size: 1.4rem;
            padding: 0 10px 0 0;

            .-v-html {
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                text-overflow: ellipsis;

                [class*="desktop_l"] & {
                   -webkit-line-clamp: 1;
                }
                [class*="desktop_xl"] & {
                   -webkit-line-clamp: 1;
                }
            }
        }
    }
</style>
